import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import App from './App.vue'

Vue.use(VueRouter);
Vue.use(Vuex);

import store from './store'

import Start from './pages/Start.vue';
import Quiz from './pages/Quiz.vue';
import Result from './pages/Result.vue';

Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      component: Start,
    },
    {
      path: '/quiz/:id',
      name: 'quiz',
      component: Quiz,
    },
    {
      path: '/result',
      name: 'result',
      component: Result,
    },
  ]
})

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
}).$mount('#app')
